import { createSlice } from '@reduxjs/toolkit'

export const estadoInicial = {
  idLista: null,
  idVendedor: 0,
  nombreLista: '',
  vigenciaDesde: '',
  vigenciaHasta: '',
  vigenciaHastaOriginal: '',
  grilla: [
    {
      zona: '',
      cantidadDesde: 0,
      cantidadHasta: 0,
      moneda: '',
      costo: 0,
      tEstimado: 0,
      posicion: 1
    }
  ]
}

const initialState = {
  show: false,
  size: '',
  body: '',
  title: '',
  items: [],
  type: '',
  campos: [],
  errores: {},
  editMode: false,
  values: estadoInicial,
  metadata: {}
}

const genericModalSlice = createSlice({
  name: 'genericModal',
  initialState,
  reducers: {
    eliminarFilaGrid: (state, action) => {
      const index = action.payload
      const grillaActual = state.values.grilla || []
      const siguiente = grillaActual.filter((_, i) => i !== index)

      state.values.grilla = siguiente.length ? siguiente : grillaActual
    },
    copiarCampoGrid: (state, action) => {
      const { name, value } = action.payload
      const filasCopiadas = state.values.grilla
      const camposCambiados = filasCopiadas.map((f) => ({
        ...f,
        [name]: value
      }))
      state.values.grilla = camposCambiados
    },
    setEstadoInicial: (state) => {
      state.values = estadoInicial
    },
    resetModal: (state) => {
      state.show = false
      state.size = ''
      state.body = ''
      state.title = ''
      state.items = []
      state.type = ''
      state.errores = {}
      state.editMode = false
      state.values = estadoInicial
      state.isForm = false
      state.metadata = {}
    },
    setModal: (state, action) => {
      const { values, ...rest } = action.payload
      if (values) {
        state.values = { ...state.values, ...values }
      }
      Object.assign(state, rest)
    }
  }
})

export const {
  eliminarFilaGrid,
  copiarCampoGrid,
  setEstadoInicial,
  resetModal,
  setModal
} = genericModalSlice.actions
export default genericModalSlice.reducer
